import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticleCTA() {
  return (
    <section id="articles" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100/80 text-accent-800 text-xs font-medium mb-6">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-article-line"></i>
            </div>
            <span className="whitespace-nowrap">In-Depth SEO Articles &bull; 10 Expert Guides</span>
          </div>

          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
            Sugargoo Spreadsheet Knowledge Base
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Explore our collection of comprehensive, original SEO articles covering everything from beginner tutorials to advanced shopping strategies. Each guide is researched, written, and updated to help you shop smarter.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="relative w-full h-44 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-background-50/90 text-xs font-medium text-foreground-700 whitespace-nowrap">
                    {article.readTime} min read
                  </span>
                </div>
              </div>
              <div className="p-5 flex flex-col flex-1">
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed mb-4 line-clamp-2 flex-1">
                  {article.description}
                </p>
                <div className="flex items-center justify-between pt-3 border-t border-background-100">
                  <span className="text-xs text-foreground-400">{article.dateUpdated}</span>
                  <span className="flex items-center gap-1 text-xs font-medium text-primary-600 whitespace-nowrap">
                    Read Article
                    <div className="w-3.5 h-3.5 flex items-center justify-center">
                      <i className="ri-arrow-right-line text-xs"></i>
                    </div>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}